<div id="academy-courses" class="page-layout simple">
    <!-- HEADER -->
    <div
        class="header accent p-16 p-sm-24"
        fxLayout="column"
        fxLayoutAlign="center center"
    >
        <div class="hero-text">
            <mat-icon class="hero-icon">school</mat-icon>
            <h1
                [@animate]="{
                    value: '*',
                    params: { delay: '100ms', y: '25px' }
                }"
            >
                Trabajos Practicos
            </h1>
        </div>
    </div>
    <!-- CONTENT -->
    <div
        class="mb-24"
        fxLayout="column"
        fxLayoutAlign="start"
        fxLayout.gt-lg="row"
        fxLayout.gt-md="column"
    >
        <!-- REACTIVE FORM EXAMPLE -->

        <form
            class="mat-card mat-elevation-z4 p-24 mr-24"
            fxLayout="column"
            fxLayoutAlign="start"
            fxFlex="1 0 auto"
            name="form"
            [formGroup]="form"
            style="height: 200px"
        >
            <div class="h2 mb-24">Crear Trabajos</div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                    <mat-label>Seleccionar Materia</mat-label>
                    <mat-select required formControlName="materia">
                        <mat-option value="Materia 1"> Materia 1 </mat-option>
                        <mat-option value="Materia 1"> Materia 2 </mat-option>
                        <mat-option value="Materia 1"> Materia 3 </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text"
                        >outlined_flag</mat-icon
                    >
                    <mat-error>Por favor seleccione la materia.</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                    <mat-label>Seleccionar Unidad</mat-label>
                    <mat-select required formControlName="unidad">
                        <mat-option> Unidad 1 </mat-option>
                        <mat-option> Unidad 2 </mat-option>
                        <mat-option> Unidad 3 </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text"
                        >outlined_flag</mat-icon
                    >
                    <mat-error>Por favor seleccione la unidad.</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="nombre" required />
                    <mat-icon matSuffix class="secondary-text"
                        >account_circle</mat-icon
                    >
                    <mat-error>Por favor ingrese el nombre.</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="end">
                <button mat-button color="accent" (click)="crearTrabajo()">
                    Crear Trabajo
                </button>
            </div>
        </form>
        <form
            class="mat-card mat-elevation-z4 p-24"
            fxLayout="column"
            fxLayoutAlign="start"
            fxFlex="1 0 auto"
            name="form"
            [formGroup]="form"
            style="height: 500px"
        >
            <div class="h2 mb-24">Revisar Trabajos</div>

            <mat-table
                class="products-table"
                #table
                [dataSource]="dataSource"
                matSort
                [@animateStagger]="{ value: '50' }"
                fusePerfectScrollbar
            >
                <!-- Columna Pregunta -->
                <ng-container matColumnDef="Materia">
                    <mat-header-cell *matHeaderCellDef mat-sort-header
                        >Materia
                    </mat-header-cell>
                    <mat-cell *matCellDef="let trabajo">
                        <p class="text-truncate">
                            {{ trabajo.MATERIA }}
                        </p>
                    </mat-cell>
                </ng-container>
                <!-- Columna Unidad -->
                <ng-container matColumnDef="Unidad">
                    <mat-header-cell *matHeaderCellDef mat-sort-header
                        >Unidad
                    </mat-header-cell>
                    <mat-cell *matCellDef="let trabajo">
                        <p class="text-truncate">
                            {{ trabajo.UNIDAD }}
                        </p>
                    </mat-cell>
                </ng-container>
                <!-- Columna Nombre -->
                <ng-container matColumnDef="Nombre">
                    <mat-header-cell *matHeaderCellDef mat-sort-header
                        >Nombre
                    </mat-header-cell>
                    <mat-cell *matCellDef="let trabajo">
                        <p class="text-truncate">
                            {{ trabajo.NOMBRE }}
                        </p>
                    </mat-cell>
                </ng-container>
                <!-- Columna Acciones -->
                <ng-container matColumnDef="Acciones">
                    <mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        fxShow.gt-md
                        >Acciones</mat-header-cell
                    >
                    <mat-cell *matCellDef="let product" fxHide fxShow.gt-md>
                        <button
                            mat-button
                            color="accent"
                            (click)="editarTrabajo()"
                        >
                            Editar
                        </button>
                        <button
                            mat-button
                            color="warn"
                            (click)="eliminarTrabajo()"
                        >
                            Eliminar
                        </button>
                    </mat-cell>
                </ng-container>

                <!-- Columna Unidad 
                <ng-container matColumnDef="unidad">
                    <mat-header-cell *matHeaderCellDef mat-sort-header
                        >Unidad</mat-header-cell
                    >
                    <mat-cell *matCellDef="let unidad">
                        <p class="text-truncate">
                            Unidad ingresada
                        </p>
                    </mat-cell>
                </ng-container>-->
                <!-- Columna Peso 
                <ng-container matColumnDef="peso">
                    <mat-header-cell *matHeaderCellDef mat-sort-header
                        >Peso</mat-header-cell
                    >
                    <mat-cell *matCellDef="let unidad">
                        <p class="text-truncate">
                            Peso Ingresado
                        </p>
                    </mat-cell>
                </ng-container>-->

                <!-- Columna Acciones -->

                <mat-header-row
                    *matHeaderRowDef="displayedColumns; sticky: true"
                ></mat-header-row>

                <mat-row
                    *matRowDef="let product; columns: displayedColumns"
                    class="product"
                    matRipple
                >
                </mat-row>
            </mat-table>
        </form>
    </div>
</div>
